// import { PaasRender } from './paasRender'
// import { CloudRender } from './cloudRender'
// 8fff55e8-43db-4641-9592-6926e2962047
import draw from "util/draw"
import { preloadImage } from "common/common"
import { Graphics } from "common/enums"
import wbManager from "media/white-board-manager"
import eventRegistry from 'common/event-registry'
import logger from 'common/logger'
class Render {
  constructor (painter, pageStore) {
    this.painter = painter
    this.pageStore = pageStore
  }
  /**
   * 全量重新绘图
   */
  _drawMousePoint (paintObj) {
    this._drawAllPaint()
    // this._emptyCanvas()
    draw[Graphics.POINT](this.painter.canvasCtx, paintObj, this.painter.scaleRatio)
  }
  _drawAllPaint() {
    this._emptyCanvas()
    if (this.pageStore && this.painter.parentEle) {
      let paintObjs = this.pageStore.findPagePaints(this.pageStore.getCurPage())
      paintObjs.map((item) => {
        this._drawPaint(item.type, item[item.type])
      })
    }
  }
   /**
   * 设置背景图(重试10次)
   */
   _insertImage (n = 0) {
    if (n > 10) return
    const convertPath = this.pageStore.getConvertFilePath()
    const curPage = this.pageStore.getCurPage()
    const fullPath = `${convertPath}/${curPage}.jpg`
    if (wbManager.cacheFileUrlMap.get(convertPath) && wbManager.cacheFileUrlMap.get(convertPath).get(fullPath)) {
      let imgUrl = wbManager.cacheFileUrlMap.get(convertPath).get(fullPath)
      preloadImage(imgUrl, () => {
        if (this.painter.canvasEle) {
          this.painter.canvasEle.style.backgroundColor = ""
          this.painter.canvasEle.style.background = "black url('"+ imgUrl +"')";
          this.painter.canvasEle.style.backgroundSize = "100% 100%";
        } else {
          logger.warn("Invalid canvas element!");
        }
      })
    } else {
      wbManager._getFileUrl(fullPath)
      setTimeout((() => {
        this._insertImage(++n)
      }).bind(this), 500)
    }
  }
  /**
   * 清除画板
   */
  _emptyCanvas() {
    if (this.painter.canvasCtx) {
      switch (this.painter.rotateAngle) {
        case 0: 
        case 180: 
          this.painter.canvasCtx.clearRect(0, 0, this.painter.canvasWidth, this.painter.canvasHeight);
          break;
        case 90:  // 这个时候宽高值已经设置转换
        case 270: 
        this.painter.canvasCtx.clearRect(0, 0, this.painter.canvasHeight, this.painter.canvasWidth);
      }
    }
  }
  /**
   * 根据图形绘图
   * @param {*} type 
   * @param {*} obj 
   */
  _drawPaint (type, obj) {
    if (this.painter.canvasCtx) {
      try {
        if (type === Graphics.PIC) {
          draw[type](this.painter.canvasCtx, obj, this.painter.scaleRatio, () => {
            // 图片第一次加载重现绘制 第二次不会触发
            this._drawAllPaint()
          })
        } else {
          draw[type](this.painter.canvasCtx, obj, this.painter.scaleRatio)
        }
       
      } catch (err) {
        logger.error("Draw type: " + type + ", error: " + err);
      }
    }
  }
  drawAmendData (pageData, paintObj) {
    this._drawAllPaint()
  }
  /**
   * 修改/删除/新增 图元
   * @param {*} paintObj 
   */
  dealAmendData (paintObj) {
    let pageData = this.pageStore.findPagePaints(this.pageStore.getCurPage())
    if (paintObj[paintObj.type].action === 1) { // 添加
      this.pageStore.addPaintObj(pageData, paintObj)
      this.drawAmendData(pageData, paintObj)
    } else if (paintObj[paintObj.type].action === 2) { // 修改
      this.pageStore.amendPaintObj(pageData, paintObj)
      this.drawAmendData(pageData, paintObj)
    } else if (paintObj[paintObj.type].action === 3) { // 删除
      this.pageStore.deletePaintObj(pageData, paintObj[paintObj.type].gid)
      this._drawAllPaint()
    } else if (paintObj[paintObj.type].action === 4) {
      this.pageStore.repalcePaintObj(pageData, paintObj[paintObj.type].gid, paintObj[paintObj.type])
      this._drawAllPaint()
    }
  }

  /**
   * 页变化
   * @param {*} pageObj 
   */
  pageChange (pageObj) {
    let pageItem = pageObj[pageObj.type]
    if (pageItem.action === 0) { // 切换页
      this.pageStore.setCurPage(pageItem.pid)
      if (this.pageStore.getFilePath()) {
        this.painter.canvasManager.setBackgroundImage()
        // this._insertImage()
      }
      this._drawAllPaint()
      // 通知白板页切换
      eventRegistry.trigger("onWhiteBoardCurPageChanged", {
        mediaId: this.painter.mediaId, 
        curPage: this.pageStore.getCurPage()
      })
    } else if (pageItem.action === 1) { // 添加页
      this.pageStore.addPage(pageItem)
    } else if (pageItem.action === 2) { // 删除页
      this.pageStore.deletePage(pageItem)
    } else if (pageItem.action === 3) { // 清空图元
      this._emptyCanvas()
      this.pageStore.clearPaints()
    } else { // 清空图元
      logger.warn("Unexpected action: " + pageItem.action);
    }
  }
  /**
   * 移动图元
   * @param {*} paintObj 
   */
  moveGraph (paintObj) {
    let pageData = this.pageStore.findPagePaints(paintObj.gmov.pid)
    paintObj.gmov.graphs.map((gid) => {
      this.pageStore.movePaintObj(pageData, gid, paintObj.gmov)
    })
    this._drawAllPaint()
  }
  // 绘制包围盒
  drawBoundingRect (obj) {
    if (!obj) return
    this.painter.canvasCtx.beginPath()
    this.painter.canvasCtx.lineWidth = 1 // 线宽
    this.painter.canvasCtx.strokeStyle = '#0000ff' // 线颜色

    let x1 = parseInt(obj.x1) * this.painter.scaleRatio
    let y1 = parseInt(obj.y1) * this.painter.scaleRatio;
    let x2 = parseInt(obj.x2) * this.painter.scaleRatio;
    let y2 = parseInt(obj.y2) * this.painter.scaleRatio;

    this.painter.canvasCtx.rect(x1, y1, (x2 - x1), (y2 - y1));
    this.painter.canvasCtx.closePath();
    this.painter.canvasCtx.stroke();
  }
}

export default Render